export const DATA_COLLECTION_PERIOD_MAX_LENGTH = 128;
export const FUNCTIONAL_UNIT_MAX_LENGTH = 128;
